module.exports = __webpack_public_path__ + "static/media/20.c8f4cdc3.svg";